
window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
}
window.BSS_B2B.addFilter = (tag,  value) => {
    window.bssB2BHooks.filters[tag] = value;
}


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

const isPDP = window.location.pathname.includes("/products/");

if (isPDP) {
  let oldHref = location.href;

  new MutationObserver(() => {
    if (oldHref !== location.href) {
      oldHref = location.href;

      const variantId = new URL(location.href).searchParams.get("variant");
      if (!variantId) return;

      const productForm = document.querySelector("[bss-b2b-main-product-form]");
      if (!productForm) return;

      const variantInput = productForm.querySelector("[bss-b2b-variant-id]");
      if (!variantInput) return;

      variantInput.setAttribute("bss-b2b-variant-id", variantId);

      variantInput.dispatchEvent(new Event("change", { bubbles: true }));

      console.log("variantInput: ", variantInput)
      if (window.BSS_B2B?.observer?.productSubject) {
        setTimeout(() => {
          window.BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { productForm }
          );
        }, 1500);
      }
    }
  }).observe(document, {
    subtree: true,
    childList: true
  });
}


document.addEventListener("click", function (e) {
  const btn = e.target.closest("[bss-b2b-btn-quickview]");
  if (!btn) return;

  setTimeout(() => {

     const variantSpan = document.querySelector(".bss-variant-id");
  const priceBox = document.querySelector("[bss-b2b-quickview-product-form] [bss-b2b-variant-id]");

  if (variantSpan && priceBox) {
    const observer = new MutationObserver(() => {
      const variantId = variantSpan.textContent.trim();
      if (!variantId) return;

      priceBox.setAttribute("bss-b2b-variant-id", variantId);

      if (window.BSS_B2B?.observer?.productSubject) {
        const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
        if (!productForm) return;

        setTimeout(() => {
          window.BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { productForm }
          );
        }, 1500);
      }
    });

    observer.observe(variantSpan, {
      childList: true,
      subtree: true
    });
  }
    
  }, 1000);
});

window.BSS_B2B.addFilter('detect:product_variant', (curVariantId, { productFormId }) => {
  if(window.location.pathname.includes("/products/")) {
    const urlParams = new URLSearchParams(window.location.search);
    curVariantId = +urlParams.get("variant");
  }
  else {
    const variantSpan = document.querySelector(".bss-variant-id");
    curVariantId = Number(variantSpan.textContent.trim());
  }
  console.log("curVariantId: ",curVariantId)
  return curVariantId;
});

